/* @flow weak */
/*
  Afterware for Apollo client
  http://dev.apollodata.com/core/network.html#networkInterfaceAfterware

  This thread was helpful:
  https://github.com/apollostack/apollo-client/issues/657#issuecomment-258440056
 */

// NOTE imports are dynamic to prevent cyclic dependencies
// import AuthActions from 'auth/AuthActions';

// message we're getting:
// 401 - {"error":"Unauthorized","code":"unauthenticated","message":"Unauthorized"}
const has401 = (errors) => errors.some(err => err.message.startsWith('401 '));

export const detect401 = {
  applyAfterware({ response }, next) {
    if (response.ok) {
      return response.clone().json().then(({ errors }) => {
        if (errors && has401(errors)) {
          console.warn('Received a 401 in GraphQL response. Expiring user session.');
          const AuthActions = require('auth/AuthActions').default;
          AuthActions.expireSession();
        } else {
          next();
        }
      });
    }

    next();
    return Promise.resolve();
  },
};

export const logNetworkErrors = {
  applyAfterware({ response }, next) {
    // TODO improve apollo-client so batching doesn't change the afterware
    // contract so much. Batched network requests pass in just {data} here,
    // while singular network requests each have HTTP info like `ok`.
    if (response.data || response.ok) {
      next();
    } else if (response.clone) {
      response.clone().text()
        .then(bodyText => {
          console.error(`Network Error: ${response.status} (${response.statusText}) - ${bodyText}`);
          next();
        })
        .catch(() => console.error('response clone failed'));
    } else {
      console.warn('GraphQL response missing data', response);
      next();
    }
  },
};

export const detect503 = {
  applyAfterware({ response }, next) {
    if (response.status === 503) {
      const ToastActions = require('actions/ToastActions').default;
      ToastActions.showErrorToast(
        'We are currently experiencing some technical issues. Try again later.'
      );
      return;
    }
    next();
  },
};



// WEBPACK FOOTER //
// ./src/lib/afterware.js